// ============================================================================
// GERMAN TRANSLATIONS - BIBLE VERSES
// ============================================================================
// Sammlung inspirierender Bibelverse mit Strong-Referenzen

export const bibleVerses = [
  {
    reference: "Philipper 4:13",
    text: "Ich vermag alles durch den, der mich mächtig macht",
    version: "Luther 1984",
    theme: "kraft",
    strongNumbers: {
      "vermag": "G1411", // δύναμις (dynamis) = Kraft, Macht
      "mächtig macht": "G1743" // ἐνδυναμόω (endynamoo) = stärken
    },
    context: "Paulus spricht über seine Fähigkeit, mit allen Situationen durch Christus umzugehen"
  },
  {
    reference: "Psalm 23:1",
    text: "Der HERR ist mein Hirte, mir wird nichts mangeln",
    version: "Luther 1984",
    theme: "schutz",
    strongNumbers: {
      "Hirte": "H7462", // רָעָה (ra'ah) = weiden, hüten
      "mangeln": "H2637" // חָסֵר (chaser) = fehlen, mangeln
    },
    context: "David drückt sein vollständiges Vertrauen in Gottes Fürsorge aus"
  },
  {
    reference: "Johannes 3:16",
    text: "Denn also hat Gott die Welt geliebt, dass er seinen eingeborenen Sohn gab",
    version: "Luther 1984",
    theme: "liebe",
    strongNumbers: {
      "geliebt": "G25", // ἀγαπάω (agapao) = bedingungslos lieben
      "gab": "G1325" // δίδωμι (didomi) = geben, schenken
    },
    context: "Der bekannteste Vers über Gottes Liebe zur Menschheit"
  },
  {
    reference: "Philipper 4:7",
    text: "Und der Friede Gottes, der höher ist als alle Vernunft, wird eure Herzen bewahren",
    version: "Luther 1984",
    theme: "friede",
    strongNumbers: {
      "Friede": "G1515", // εἰρήνη (eirene) = Friede, Harmonie
      "bewahren": "G5432" // φρουρέω (phroureo) = bewachen, schützen
    },
    context: "Verheißung göttlichen Schutzes durch inneren Frieden"
  },
  {
    reference: "Psalm 119:105",
    text: "Dein Wort ist meines Fußes Leuchte und ein Licht auf meinem Wege",
    version: "Luther 1984",
    theme: "führung",
    strongNumbers: {
      "Leuchte": "H5216", // נִיר (niyr) = Lampe, Leuchte
      "Licht": "H216" // אוֹר (or) = Licht, Erleuchtung
    },
    context: "Gottes Wort als Wegweiser im täglichen Leben"
  },
  {
    reference: "Sprüche 3:5-6",
    text: "Vertraue auf den HERRN von ganzem Herzen und verlass dich nicht auf deinen Verstand",
    version: "Luther 1984",
    theme: "vertrauen",
    strongNumbers: {
      "Vertraue": "H982", // בָּטַח (batach) = vertrauen
      "Herzen": "H3820" // לֵב (leb) = Herz, Verstand, Wille
    },
    context: "Einladung, auf Gott statt auf eigene Fähigkeiten zu vertrauen"
  },
  {
    reference: "Matthäus 5:14",
    text: "Ihr seid das Licht der Welt. Es kann die Stadt, die auf einem Berge liegt, nicht verborgen sein",
    version: "Luther 1984",
    theme: "zeugnis",
    strongNumbers: {
      "Licht": "G5457", // φῶς (phos) = Licht, geistliche Erleuchtung
      "Welt": "G2889" // κόσμος (kosmos) = Welt, Universum
    },
    context: "Jesus ermutigt seine Jünger, Zeugen in der Welt zu sein"
  }
];

export default bibleVerses;
